"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSizeSelector = fontSizeSelector;

function getActiveSize(type, size) {
  switch (type) {
    case "body":
      return size;

    case "heading":
      return "$".concat(size);

    default:
      return undefined;
  }
}

function fontSizeSelector(props, type, size) {
  var _props$theme, _props$theme$typograp, _props$theme$typograp2;

  var activeSize = getActiveSize(type, size);
  return activeSize ? (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$typograp = _props$theme.typography) === null || _props$theme$typograp === void 0 ? void 0 : (_props$theme$typograp2 = _props$theme$typograp.fontSize) === null || _props$theme$typograp2 === void 0 ? void 0 : _props$theme$typograp2[type][activeSize] : undefined;
}